export const GET_STARTUPS_ATTEMPT = 'GET_STARTUPS_ATTEMPT';
export const GET_STARTUPS_SUCCESS = 'GET_STARTUPS_SUCCESS';
export const GET_STARTUPS_FAILURE = 'GET_STARTUPS_FAILURE';

export const GET_SECTORS_STARTUPS_ATTEMPT = 'GET_SECTORS_STARTUPS_ATTEMPT';
export const GET_SECTORS_STARTUPS_SUCCESS = 'GET_SECTORS_STARTUPS_SUCCESS';
export const GET_SECTORS_STARTUPS_FAILURE = 'GET_SECTORS_STARTUPS_FAILURE';

export const CLEAR_STATE = 'CLEAR_STATE';
